import { createContext } from 'react'

export const OnboardingContext = createContext<{
  loginFlow: undefined | boolean
  bottomSheetPortal: HTMLDivElement | null
}>({
  loginFlow: undefined,
  bottomSheetPortal: null,
})
